var collapsible_list_component_rtlignore_default = {
  "ltr": "npEpf",
  "rtl": "bOvX1",
  "iconContainer": "uzD6s",
  "icon": "KU-lu",
  "isExpanded": "TLz2i",
  "listDimensions": "ZXSQJ"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
